import { createTheme } from '@mui/material/styles';

import { baseTheme, getCommonThemesProps } from './baseTheme';
import { hemeraColors } from './colors';

export const themeHemera = () => {
  const theme = baseTheme();

  const themeProperties = getCommonThemesProps(hemeraColors);
  const { palette, components } = themeProperties;

  return createTheme({
    breakpoints: theme.breakpoints,
    palette,
    components,
    customLogo: {
      logo: 'HEMERA_LOGO',
      slogo: 'HEMERA_SLOGO',
      nlogo: 'HEMERA_NLOGO',
      clogo: 'HEMERA_CLOGO',
    },
    verticalBreakpoints: theme.verticalBreakpoints,
    typography: theme.typography,
  });
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  window.theme = themeHemera();
}
